<!--<div *ngFor="let item of authSearchResults">-->
  <app-auth-search [item]="authSearchResults"
                   (clickAction1)="viewAllAuth()"
                   (clickAction2)="viewAuth()">
  </app-auth-search>
<!--</div>-->
